import { useQuery } from '@tanstack/react-query';

import { useAccessTokenStore } from 'api/authentication/store/useAccessTokenStore';
import { CONFIG_BASE_URL, fetchConfiguration } from 'api/configuration/configuration-api';
import { resolve } from 'api/resolve';
import { isLocalDev, isTesting } from 'utils/env';
import { hasValue } from 'utils/values';

import type { AppConfiguration } from '../types';

/** Fetch app configuration */
export const useConfigurationService = <T>(select?: (data: AppConfiguration) => T) => {
  const database = useAccessTokenStore((state) => state.accessTokenPayload?.database);

  return useQuery({
    queryKey: [CONFIG_BASE_URL, database],
    queryFn: () => resolve(fetchConfiguration()),
    // Use .env.local to configure feature flags for local development.
    // It should be enabled for testing.
    enabled: hasValue(database) && (!isLocalDev || isTesting),
    select
  });
};
